module.exports = __webpack_public_path__ + "media/images/background-team-1440w-b938e37a.jpg";